import React, { useState, useEffect } from "react";
import { SelectButton } from "primereact/selectbutton";
import "./ANMProfile.scss";
import ActiveInactiveAnmTable from "./ActiveInactiveAnmTable";

const ListOfAshas = ({ anmId, ashalist }) => {
  const data = [`Active`, `Inactive`];
  const [value, setValue] = useState(data[0]);
  const [activeList, setActiveList] = useState([]);
  const [inactiveList, setInactiveList] = useState([]);

  useEffect(() => {
    if (!ashalist) {
      console.error("Error: ashalist is not present.");
      return;
    }
    const activeListData = ashalist.filter((item) => item.isactive === 'Active') || [];
    const inactiveListData = ashalist.filter((item) => item.isactive === 'Inactive') || [];
    setActiveList(activeListData);
    setInactiveList(inactiveListData);
  }, [ashalist]);

  const handleValue = (val) => {
    setValue(val);
  };

  const renderComponent = () => {
    if (value === "Active") {
      return <ActiveInactiveAnmTable dataList={activeList} />;
    } else if (value === "Inactive") {
      return <ActiveInactiveAnmTable dataList={inactiveList} />;
    } else {
      return null;
    }
  };

  return (
    <>
      <SelectButton
        className="profile-select-btn"
        value={value}
        onChange={(e) => {
          handleValue(e.value);
        }}
        options={data}
      />
      {renderComponent()}
    </>
  );
};

export default ListOfAshas;
